import { useState } from "react";
import { TbWorldWww } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import { DiscountIcon } from "../../assets/designedPickedIcons";
import dummyPhoto from "../../assets/place-dummy-1.png";
import { useDealsHooks } from "../../hooks/useDealsHooks";
import AddDeals from "../modals/AddDeals";
import { showInFullScreen } from "../specials/FullScreenView";
import { useTranslation } from "../../languages";
import _axios from "../../axios.config";
import { toast } from "react-toastify";
import { setPlaceDetails } from "../../redux/action";

const ResturantBasicDetails = () => {
  const user = useSelector((s) => s?.user ?? {});
  const details = useSelector((s) => s?.placeDetails ?? {});
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const {
    //all local states

    dealData,
    setDealData,

    //all functions
    handleClearData,
    handleDaysSelect,
    onPressDoneBtn,
  } = useDealsHooks(setModalOpen);
  const isAlreadyReserved = details?.reservationClickers?.find(
    (obj) => obj?.user === user?._id
  );
  const dispatch = useDispatch();

  const handleReservationClick = async () => {
    try {
      let response = await _axios.post(
        `api/place/${details?._id}/reservation-click`
      );
      console.log("Reservation log......", response);
      if (response?.status === 200) {
        toast.success("Reserved successfully");
        dispatch(
          setPlaceDetails({
            ...details,
            reservationClickers: Array.isArray(details?.reservationClickers)
              ? [...details?.reservationClickers, { user: user?._id }]
              : [{ user: user?._id }],
          })
        );
      }
    } catch (e) {
      toast.error("Cannot reserve , there seems to be error");
    }
  };

  return (
    <div className="position-relative">
      <h4
        className="f-5 color-primary-black-1 text-white my-3 text-center"
        style={{ letterSpacing: "9px" }}
      >
        {details?.types?.[0]}
      </h4>

      <div>
        <div className="resturant-detail-div">
          <div className=" p-3" style={{ borderRadius: "6px" }}>
            <Row className="gy-1 gx-3">
              <Col md={7}>
                <img
                  onClick={(e) =>
                    showInFullScreen(e?.target, [
                      details?.photos[0],
                      details?.photos[1] || dummyPhoto,
                    ])
                  }
                  style={{
                    borderRadius: "6px",
                    border: "2px solid rgba(202, 149, 69, 1)",
                  }}
                  height={250}
                  src={details?.photos?.[0] || dummyPhoto}
                  className="full-width clickable-photo object-fit-cover"
                  alt="img"
                />
              </Col>
              <Col md={5}>
                <img
                  onClick={(e) =>
                    showInFullScreen(e?.target, [
                      details?.menuImages?.[0],
                      details?.menuImages?.[1] || dummyPhoto,
                    ])
                  }
                  style={{
                    borderRadius: "6px",
                    border: "2px solid rgba(202, 149, 69, 1)",
                  }}
                  height={250}
                  src={details?.menuImages?.[0]}
                  className="full-width clickable-photo  object-fit-cover"
                  alt="img"
                />
              </Col>
              <Col
                md={12}
                className="d-flex justify-content-center align-items-center gap-2"
              >
                <p
                  className="mt-2"
                  style={{
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {details?.description}
                </p>
              </Col>
            </Row>
          </div>

          <div className="d-flex px-3 algin-items-center flex-wrap gap-1 flex-md-nowrap justify-content-between mt-3 mb-3">
            <h5 className="m-0">
              <span className="text-success f-5 ">Open Times : </span>
              <span className="color-primary-black-3">(Close 12am)</span>
              <span className="color-primary-black-3 mx-2">25 minutes</span>
            </h5>
          </div>
          <div className="d-flex my-4 flex-lg-nowrap flex-md-wrap align-items-center gap-2 justify-content-between">
            <h5 className="m-0 px-3 f-5">
              <span className="color-primary-black-3">
                <TbWorldWww size={30} />
              </span>
              <Link
                to={details?.reservationLink}
                className="color-primary-blue mx-2"
              >
                Visit Website
              </Link>
            </h5>
          </div>

          <h5 className="f-5 m-0  color-primary-black-3 px-3">
            Location :
            <span className="f-4 m-3 color-primary-black-3">
              {details?.location?.streetAddress}
            </span>
          </h5>
          <div className="text-center mt-5 mb-5">
            {isAlreadyReserved ? (
              <Button
                style={{ minWidth: "75%" }}
                className="bg-success text-white rounded-pill px-3 py-3 "
              >
                Reserved
              </Button>
            ) : (
              <Button
                onClick={() => {
                  setModalOpen(true);
                  if (user?.roles?.[0] === "user") handleReservationClick();
                }}
                style={{ minWidth: "75%" }}
                className="standard-rounded-btn  py-3 "
              >
                {user?.roles?.[0] === "contributor"
                  ? t("addDeals")
                  : t("bookReservation")}
              </Button>
            )}
          </div>

          <Row className="g-md-0 gy-2 m-0 no-pad-cols">
            <Col md={7}>
              <h5 className="mb-3 f-5">{t("resembelanceFor")}</h5>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                {details?.categories?.slice(0, 4)?.map((item, at) => (
                  <Button
                    key={at}
                    className="bg-white f-5"
                    style={{
                      color: item?.color,
                      borderColor: item?.color,
                      width: 121.22,
                      borderRadius: "23.15px",
                    }}
                  >
                    {item?.name}
                  </Button>
                ))}
              </div>
            </Col>
            <Col md={5} className="d-flex flex-column align-items-end  ">
              <div
                className="outer-transparent-shadow py-2 px-3"
                style={{ borderRadius: "11.02px" }}
              >
                <div className="d-flex align-items-center gap-md-0 ">
                  <div>
                    <DiscountIcon color={`rgba(18, 118, 239, 1)`} />
                    <DiscountIcon color={`rgba(254, 48, 48, 1)`} />
                    <DiscountIcon color={`rgba(56, 138, 43, 1)`} />
                  </div>
                  <div>
                    <h5 className="text-black m-0">{t("availableDiscount")}</h5>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* add deals modal */}
      {user?.roles?.[0] === "contributor" && (
        <AddDeals
          isOpen={modalOpen}
          setisOpen={setModalOpen}
          dealData={dealData}
          setDealData={setDealData}
          handleClearData={handleClearData}
          handleDaysSelect={handleDaysSelect}
          onPressDoneBtn={onPressDoneBtn}
        />
      )}
    </div>
  );
};

export default ResturantBasicDetails;
